"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const dateAdd = (date, interval, units) => {
  if (!(date instanceof Date)) return undefined;
  var ret = new Date(date); //don't change original date

  var checkRollover = () => {
    if (ret.getDate() != date.getDate()) ret.setDate(0);
  };

  switch (String(interval).toLowerCase()) {
    case 'year':
      ret.setFullYear(ret.getFullYear() + units);
      checkRollover();
      break;

    case 'quarter':
      ret.setMonth(ret.getMonth() + 3 * units);
      checkRollover();
      break;

    case 'month':
      ret.setMonth(ret.getMonth() + units);
      checkRollover();
      break;

    case 'week':
      ret.setDate(ret.getDate() + 7 * units);
      break;

    case 'day':
      ret.setDate(ret.getDate() + units);
      break;

    case 'hour':
      ret.setTime(ret.getTime() + units * 3600000);
      break;

    case 'minute':
      ret.setTime(ret.getTime() + units * 60000);
      break;

    case 'second':
      ret.setTime(ret.getTime() + units * 1000);
      break;

    default:
      ret = undefined;
      break;
  }

  return ret;
};

class _class {
  static dateMidnight(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
  }

  static addTime(date, interval, units) {
    return dateAdd(date, interval, units);
  }

  static subTime(date, interval, units) {
    return dateAdd(date, interval, -units);
  }

  static toMysqlFormat(date) {
    return date.toISOString().slice(0, 19).replace('T', ' ');
  }

  static firstDayOfMonth(year, month) {
    return new Date(year, month - 1, 1, 0, 0, 0);
  }

  static lastDayOfMonth(year, month) {
    return new Date(year, month + 1, 0, 0, 0, 0);
  }
  /**
   *  Baseado em https://gist.github.com/micah1701/4120120
   *  Return a formated string from a date Object mimicking PHP's date() functionality
   *
   * format  string  "Y-m-d H:i:s" or similar PHP-style date format string
   * date    mixed   Date Object, Datestring, or milliseconds 
   *
   */


  static format(formatter, date) {
    if (!date || date === "") {
      date = new Date();
    } else if (typeof date !== 'object') {
      // attempt to convert string to date object	
      date = new Date(date.replace(/-/g, "/"));
    }

    var mo = date.getMonth(),
        // month (0-11)
    m1 = date.getMonth() + 1,
        // month (1-12)
    dow = date.getDay(),
        // day of week (0-6)
    d = date.getDate(),
        // day of the month (1-31)
    y = date.getFullYear(),
        // 1999 or 2003
    h = date.getHours(),
        // hour (0-23)
    mi = date.getMinutes(),
        // minute (0-59)
    s = date.getSeconds(); // seconds (0-59)

    return formatter.split('').reduce((string, format) => {
      switch (format) {
        case 'j':
          // Day of the month without leading zeros  (1 to 31)
          string += d;
          break;

        case 'n':
          // Numeric representation of a month, without leading zeros (1 to 12)
          string += m1;
          break;

        case 'w':
          // Numeric representation of the day of the week (0=Sunday,1=Monday,...6=Saturday)
          string += dow;
          break;

        case 'Y':
          // A full numeric representation of a year, 4 digits (1999 OR 2003)	
          string += y;
          break;

        case 'd':
          // Day of the month, 2 digits with leading zeros (01 to 31)
          string += `${d}`.padStart(2, '0');
          break;

        case 'm':
          // Numeric representation of a month, with leading zeros (01 to 12)
          string += `${m1}`.padStart(2, '0');
          break;

        case 'i':
          // Minutes with leading zeros (00 to 59)
          string += `${mi}`.padStart(2, '0');
          break;

        case 's':
          // Seconds, with leading zeros (00 to 59)
          string += `${s}`.padStart(2, '0');
          break;

        case 'H':
          // 24-hour format of an hour with leading zeros (00 to 23)
          string += `${h}`.padStart(2, '0');
          break;

        case 'l':
          // (lowercase 'L') A full textual representation of the day of the week
          string += this.weekDays[dow];
          break;

        case 'D':
          // A textual representation of a day, three letters
          string += this.shortWeekDays[dow];
          break;

        case 'F':
          // A full textual representation of a month, such as January or March 
          string += this.monthNames[mo];
          break;

        case 'M':
          // A short textual representation of a month, three letters (Jan - Dec)
          string += this.shortMonthNames[mo];
          break;

        case 'y':
          // A two digit representation of a year (99 OR 03)
          string += y.toString().slice(-2);
          break;

        case 'g':
          // 12-hour format of an hour without leading zeros (1 to 12)
          var hour = h === 0 ? 12 : h;
          string += hour > 12 ? hour - 12 : hour;
          break;

        case 'h':
          // 12-hour format of an hour with leading zeros (01 to 12)
          hour = h === 0 ? 12 : h;
          hour = hour > 12 ? hour - 12 : hour;
          string += `${hour}`.padStart(2, '0');
          break;

        case 'a':
          // Lowercase Ante meridiem and Post meridiem (am or pm)
          string += h < 12 ? "am" : "pm";
          break;

        case 'c':
          // ISO 8601 date (eg: 2012-11-20T18:05:54.944Z)
          string += date.toISOString();
          break;

        default:
          string += format;
      }

      return string;
    }, "");
  }

  static fromFormat(format, dateString) {
    let loadedData = {
      year: "",
      day: "",
      month: "",
      hour: "",
      minute: "",
      second: ""
    };
    format.split('').forEach((format, currentIndex) => {
      switch (format) {
        case 'Y':
          // A full numeric representation of a year, 4 digits (1999 OR 2003)	
          loadedData.year += `${dateString[currentIndex]}`;
          break;

        case 'd':
          // Day of the month, 2 digits with leading zeros (01 to 31)
          loadedData.day += `${dateString[currentIndex]}`;
          break;

        case 'm':
          // Numeric representation of a month, with leading zeros (01 to 12)
          loadedData.month += `${dateString[currentIndex]}`;
          break;

        case 'i':
          // Minutes with leading zeros (00 to 59)
          loadedData.minute += `${dateString[currentIndex]}`;
          break;

        case 's':
          // Seconds, with leading zeros (00 to 59)
          loadedData.second += `${dateString[currentIndex]}`;
          break;

        case 'H':
          // 24-hour format of an hour with leading zeros (00 to 23)
          loadedData.hour += `${dateString[currentIndex]}`;
          break;
      }
    });
    return new Date(+loadedData.year, +loadedData.month - 1, +loadedData.day, +loadedData.hour || 0, +loadedData.minute || 0, +loadedData.second || 0);
  }

}

exports.default = _class;

_defineProperty(_class, "weekDays", ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]);

_defineProperty(_class, "shortWeekDays", ["Sun", "Mon", "Tue", "Wed", "Thr", "Fri", "Sat"]);

_defineProperty(_class, "monthNames", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);

_defineProperty(_class, "shortMonthNames", ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]);